import React, { HTMLAttributes } from 'react'

interface DividerProps extends HTMLAttributes<HTMLHRElement> {}

const Divider: React.FC<DividerProps> = ({ className, ...props }) => {
  return <hr {...props} className={`${className} text-divider-color`} />
}

export default Divider
